module.exports = __webpack_public_path__ + "static/img/technologybgcopy.784a647c.png";